import { PanierComponent } from './panier.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { StickyModule } from '@app/directives/sticky.module';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        StickyModule
    ],
    declarations: [
        PanierComponent
    ],
    exports: [
        PanierComponent
    ]
})

export class PanierModule {}
